import { Component, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material";
import { Observable } from "rxjs";
import { map, distinctUntilChanged } from "rxjs/operators";
import * as moment from "moment";
import { IModalAutorizacionConsulta } from "../../models/autorizaciones.interface";
import { TipoAutorizacionEnum } from "../../models/autorizaciones.model";
import { AutorizacionConsultarStore } from "../../store/autorizacion.consultar.store";

@Component({
  selector: "app-autorizacion-consultar",
  templateUrl: "./autorizacion-consultar.component.html",
  styleUrls: ["./autorizacion-consultar.component.css"],
})
export class AutorizacionConsultarComponent implements OnInit {
  state$: Observable<IModalAutorizacionConsulta>;

  preview = {
    rutas: [
      {
        nombre: "",
      },
      {
        nombre: "",
      },
    ],
    itinerario: {
      displayedColumns: ["desde", "ubigeo", "direccion", "fecha", "hora"],
      dataSource: [
        {
          desde: "Origen",
          ubigeo: "",
          direccion: "",
          fecha: "",
          hora: "",
        },
        {
          desde: "Destino",
          ubigeo: "",
          direccion: "",
          fecha: "",
          hora: "",
        },
      ],
    },
    vehiculo: {
      displayedColumns: [
        "descripcion",
        "marca",
        "modelo",
        "tipoIdentificador",
        "identificador",
        "largo",
        "ancho",
        "alto",
        "ejes",
        "neumaticos",
        "peso_seco",
      ],
      dataSource: [],
    },
    autopropulsado: {
      displayedColumns: [
        "caracteristica",
        "largo",
        "ancho",
        "alto",
        "peso_seco",
      ],
      dataSource: [
        {
          header: false,
          caracteristica: "",
          largo: "",
          ancho: "",
          alto: "",
          peso_seco: "",
        },
        {
          header: true,
          caracteristica: "",
          largo: "",
          ancho: "",
          alto: "",
          peso_seco: "",
        },
        {
          header: true,
          caracteristica: "",
          largo: "",
          ancho: "",
          alto: "",
          peso_seco: "",
        },
        {
          header: true,
          caracteristica: "Exceso anterior: 0.00m / Exceso Posterior: 0.00m",
          largo: "",
          ancho: "",
          alto: "",
          peso_seco: "",
        },
      ],
    },
    ejes: {
      displayedColumns: [
        "eje",
        "uno",
        "dos",
        "tres",
        "cuatro",
        "cinco",
        "seis",
        "siete",
      ],
      dataSource: [
        {
          eje: "Peso",
          uno: "",
          dos: "",
          tres: "",
          cuatro: "",
          cinco: "",
          seis: "",
          siete: "",
        },
      ],
    },
    cronograma: {
      displayedColumns: [
        "origen",
        "destino",
        "fecha",
        "horaPartida",
        "horaLlegada",
      ],
      dataSource: [],
    },
  };

  rutasConsecutivasSeleccionadas: any[] = [];

  vListPesoPorEje: any[] = [];

  vCronogramaTramoList: any[] = [];

  //para la imágen de la configuración vehicular
  vConfVehicularClass = "config-vehiculo-";
  vIdConfVehicular: number;
  vIdTipoEnganche: number = 1;
  vPrimerVehiculo = { orden: 1, numEjes: 0 };
  vSegundoVehiculo = { orden: 2, numEjes: 0 };
  vTercerVehiculo = { orden: 3, numEjes: 0 };
  vVehiculoList = [
    this.vPrimerVehiculo,
    this.vSegundoVehiculo,
    this.vTercerVehiculo,
  ];

  //listado de id tipo vehiculo, debe ir en constantes
  vTipoVehiculo = {
    TRACTO: 1,
    SEMIREMOLQUE: 2,
    DOLLY: 4,
    MODULAR: 5,
    REMOLQUE: 6,
  };

  vListTipoVehiculoClass = [
    {
      idTipoVehiculo: this.vTipoVehiculo.TRACTO,
      classTipoVehiculo: "",
      prefixClass: "-t",
    },
    {
      idTipoVehiculo: this.vTipoVehiculo.DOLLY,
      classTipoVehiculo: "",
      prefixClass: "-d",
    },
    {
      idTipoVehiculo: this.vTipoVehiculo.SEMIREMOLQUE,
      classTipoVehiculo: "",
      prefixClass: "-c",
    },
    {
      idTipoVehiculo: this.vTipoVehiculo.MODULAR,
      classTipoVehiculo: "",
      prefixClass: "-m",
    },
    {
      idTipoVehiculo: this.vTipoVehiculo.REMOLQUE,
      classTipoVehiculo: "",
      prefixClass: "-r",
    },
  ];

  vShowSeccionPesoxEje: boolean = false;
  vShowSeccionCronograma: boolean = false;

  MERCANCIA2_ORDEN = 2;

  MERCANCIA_ENCIMADA = 1;
  MERCANCIA_CONTIGUA = 2;

  constructor(
    public autorizacionConsultarStore: AutorizacionConsultarStore,
    public dialogRef: MatDialogRef<AutorizacionConsultarComponent>
  ) {}

  ngOnInit() {
    this.state$ = this.autorizacionConsultarStore.state$.pipe(
      map((x) => x.modalAutorizacionConsulta),
      distinctUntilChanged()
    );

    var objModal =
      this.autorizacionConsultarStore.state.modalAutorizacionConsulta;

    this.fetchDataSolicitud(objModal.idSolicitud);
  }

  fetchDataSolicitud = (idSolicitud: number) => {
    //se trae la data de la solicitud, y se guarda en [state.modalAutorizacionConsulta.solicitud]
    this.autorizacionConsultarStore.actionModalAutorizacionConsulta
      .asyncFetchSolicitudById(idSolicitud)
      .then(
        (res) => {
          var oSolicitud =
            this.autorizacionConsultarStore.state.modalAutorizacionConsulta
              .solicitud;

          //Datos de la empresa y el representante, se trae directamente del solicitudBuscar.
          const tipoAutPesoxEje = [
            TipoAutorizacionEnum.ABM,
            TipoAutorizacionEnum.ADM,
            TipoAutorizacionEnum.AEM,
          ];
          this.vShowSeccionPesoxEje = tipoAutPesoxEje.includes(
            oSolicitud.fK_eIdTipoAutorizacion
          );

          //itinerario
          let vItinerario = oSolicitud.oItinerario;
          let dataItinerario = [
            {
              desde: "Origen",
              ubigeo: vItinerario.cUbigeoDescOrigen,
              direccion: vItinerario.cDireccionOrigen,
              fecha: moment(vItinerario.fFechaSalida).format("DD/MM/YYYY"),
              hora: vItinerario.cHoraSalida,
            },
            {
              desde: "Destino",
              ubigeo: vItinerario.cUbigeoDescDestino,
              direccion: vItinerario.cDireccionDestino,
              fecha: moment(vItinerario.fFechaSalida).format("DD/MM/YYYY"),
              hora: vItinerario.cHoraLlegada,
            },
          ];
          this.preview.itinerario.dataSource = dataItinerario;

          //tramos
          let vListTramo = oSolicitud.oListTramo;
          if (vListTramo) {
            vListTramo.forEach((oTramo) => {
              this.rutasConsecutivasSeleccionadas.push({
                cDescripcionPuntoDestino: oTramo.cUbigeoDestino || "",
                cDescripcionPuntoOrigen: oTramo.cUbigeoOrigen || "",
                cRutaDestino: oTramo.cRutaDestino,
                aRutaKmDestino: oTramo.dDestinoKM,
              });
            });
          }

          //imagen configuración vehicular
          if (oSolicitud.fK_eIdConfiguracionVehicular) {
            this.vConfVehicularClass +=
              oSolicitud.fK_eIdConfiguracionVehicular.toString();
            this.vIdConfVehicular = oSolicitud.fK_eIdConfiguracionVehicular;
            this.vIdTipoEnganche = oSolicitud.eIdTipoEnganche
              ? oSolicitud.eIdTipoEnganche
              : this.vIdTipoEnganche;
          }

          //vehiculos
          let vListVehiculo = oSolicitud.oListVehiculo;
          if (vListVehiculo) {
            let vDataVehiculo: any[] = [];
            let vNumEjesModular: number = 0;
            let vIndexModular: number = null;

            vListVehiculo.forEach((oVehiculo, index) => {
              const dataVehic = {
                descripcion: oVehiculo.cTipoVehiculo,
                marca: oVehiculo.cMarca,
                modelo: oVehiculo.cModelo,
                tipoIdentificador: oVehiculo.cTipoIdentificador,
                identificador: oVehiculo.cIdentificador,
                largo: oVehiculo.dLargo,
                ancho: oVehiculo.dAncho,
                alto: oVehiculo.dAlto,
                ejes: oVehiculo.eNumEjes,
                neumaticos: oVehiculo.eNumNeumaticos,
                peso_seco: oVehiculo.dPesoSeco,
              };
              vDataVehiculo.push(dataVehic);

              //define el nro de ejes por el tipo de vehiculo, para la clase de tipo de vehiculo.
              let indexTipoVehiculoClass =
                this.vListTipoVehiculoClass.findIndex(
                  (p) => p.idTipoVehiculo === oVehiculo.fK_eIdTipoVehiculo
                );
              let vClassTipoVehiculo = "";

              if (oVehiculo.eNumEjes !== 0) {
                if (
                  this.vListTipoVehiculoClass[indexTipoVehiculoClass]
                    .idTipoVehiculo === this.vTipoVehiculo.MODULAR
                ) {
                  vClassTipoVehiculo =
                    this.vListTipoVehiculoClass[indexTipoVehiculoClass]
                      .prefixClass;
                  vIndexModular =
                    vIndexModular === null ? index + 1 : vIndexModular;
                  vNumEjesModular += oVehiculo.eNumEjes;
                } else {
                  vClassTipoVehiculo =
                    this.vListTipoVehiculoClass[indexTipoVehiculoClass]
                      .prefixClass + oVehiculo.eNumEjes;
                  let indexVehiculo = this.vVehiculoList.findIndex(
                    (p) => p.orden === index + 1
                  );
                  this.vVehiculoList[indexVehiculo].numEjes =
                    oVehiculo.eNumEjes;
                }
              }

              this.vListTipoVehiculoClass[
                indexTipoVehiculoClass
              ].classTipoVehiculo = vClassTipoVehiculo;
            });
            this.preview.vehiculo.dataSource = vDataVehiculo;

            if (vIndexModular) {
              let indexVehiculoModular = this.vVehiculoList.findIndex(
                (p) => p.orden === vIndexModular
              );
              this.vVehiculoList[indexVehiculoModular].numEjes =
                vNumEjesModular;
            }
            //hasta que Moises soluciones el tema del primer neumático del tracto
            this.vPrimerVehiculo.numEjes =
              this.vPrimerVehiculo.numEjes === 0
                ? this.vPrimerVehiculo.numEjes
                : this.vPrimerVehiculo.numEjes - 1;
            //se agrega las clases de los tipos de vehiculos, para la imagen de la conf. vehicular.
            this.vConfVehicularClass += this.vListTipoVehiculoClass.reduce(
              function (acc, currVal) {
                return acc + currVal.classTipoVehiculo;
              },
              ""
            );
          }
          // console.log("vConfVehicularClass",this.vConfVehicularClass);

          //mercancias
          let vListMercancia = oSolicitud.oListMercancia;
          let vDataMercancia: any[] = [];
          let vExcesoParteDelantera = 0;
          let vExcesoPartePosterior = 0;
          if (vListMercancia && vListMercancia.length > 0) {
            vListMercancia.forEach((oMercancia) => {
              let vdistMercancia =
                oMercancia.eDistribucion === this.MERCANCIA_CONTIGUA
                  ? " (CONTIGUA)"
                  : oMercancia.eDistribucion === this.MERCANCIA_ENCIMADA
                  ? " (ENCIMA)"
                  : "";
              const dataMercancia = {
                //por el momento, deberia venir de la BD
                header: false,
                caracteristica:
                  (oMercancia.cDescMercaderia || oMercancia.cDescripcion) +
                  vdistMercancia,
                largo: oMercancia.dLargo,
                ancho: oMercancia.dAncho,
                alto: oMercancia.dAlto,
                peso_seco: oMercancia.dPeso,
              };
              vDataMercancia.push(dataMercancia);
              vExcesoParteDelantera =
                oMercancia.dExcesoAnterior > vExcesoParteDelantera
                  ? oMercancia.dExcesoAnterior
                  : vExcesoParteDelantera;
              vExcesoPartePosterior =
                oMercancia.dExcesoPosterior > vExcesoPartePosterior
                  ? oMercancia.dExcesoPosterior
                  : vExcesoPartePosterior;
            });

            //Total Mercancia
            if (vListMercancia.length > 1) {
              const objMedidasMercancia =
                this.getMedidasMercancia(vListMercancia);
              const dataTotalMercancia = {
                header: false,
                caracteristica: `Dimensiones Totales Mercancía:`,
                largo:
                  Math.round(
                    (objMedidasMercancia.largo + Number.EPSILON) * 100
                  ) / 100,
                ancho: objMedidasMercancia.ancho,
                alto:
                  Math.round(
                    (objMedidasMercancia.alto + Number.EPSILON) * 100
                  ) / 100,
                peso_seco:
                  Math.round(
                    (objMedidasMercancia.peso + Number.EPSILON) * 100
                  ) / 100,
              };
              vDataMercancia.push(dataTotalMercancia);
            }

            //excesos
            vDataMercancia.push({
              caracteristica:
                "Exceso Anterior: " +
                vExcesoParteDelantera +
                "m / Exceso Posterior: " +
                vExcesoPartePosterior +
                "m",
            });
          }

          //medidas totales
          vDataMercancia.push({
            header: false,
            caracteristica:
              "Dimensiones totales de vehículo incluída la mercadería",
            largo: oSolicitud.dLargoTotal,
            ancho: oSolicitud.dAnchoTotal,
            alto: oSolicitud.dAltoTotal,
            peso_seco: oSolicitud.dPesoTotal,
          });

          this.preview.autopropulsado.dataSource = vDataMercancia;

          //peso por eje
          let vDataPesoPorEje = oSolicitud.oListPesoPorEje;
          if (vDataPesoPorEje) {
            vDataPesoPorEje.forEach((oPesoEje) => {
              const dataPesoEje = {
                eNumEje: oPesoEje.eNumEje,
                dPeso: oPesoEje.dPeso,
              };
              this.vListPesoPorEje.push(dataPesoEje);
            });
          }

          //cronograma
          let vCronogramaTramo = oSolicitud.oListCronogramaTramo;
          if (vCronogramaTramo && vCronogramaTramo.length > 0) {
            vCronogramaTramo.forEach((ocronogramaBD, index) => {
              this.vCronogramaTramoList.push({
                idCronogramaTramo: 0,
                idTramo: ocronogramaBD.fK_eIdTramo,
                origen: ocronogramaBD.cOrigen,
                destino: ocronogramaBD.cDestino,
                fecha: ocronogramaBD.fFecha,
                horaPartida: ocronogramaBD.cHoraSalida,
                horaLlegada: ocronogramaBD.cHoraLlegada,
              });
            });

            let dataCronogramaPreview = this.vCronogramaTramoList.map(
              (oruta) => {
                return {
                  ...oruta,
                  fecha: moment(oruta.fecha).format("DD/MM/YYYY"),
                };
              }
            );
            this.preview.cronograma.dataSource = dataCronogramaPreview;
            this.vShowSeccionCronograma = true;
          }
        },
        (error) => {}
      );
  };

  getMedidasMercancia = (lstMercancia) => {
    let objMedidasMercancia = { peso: 0, ancho: 0, largo: 0, alto: 0 };

    if (lstMercancia && lstMercancia.length > 0) {
      if (lstMercancia.length === 1) {
        //una sola mercancia
        let objMercancia = lstMercancia[0];
        objMedidasMercancia.peso = objMercancia.dPeso;
        objMedidasMercancia.largo = objMercancia.dLargo;
        objMedidasMercancia.ancho = objMercancia.dAncho;
        objMedidasMercancia.alto = objMercancia.dAlto;
      } else {
        //dos mercancías
        //se obtiene la distribución de las mercancías
        let objMercancia2 = lstMercancia.find((item) => {
          return item.eOrden === this.MERCANCIA2_ORDEN;
        });
        let distribucionMerc = objMercancia2.eDistribucion;

        lstMercancia.forEach((objMercancia) => {
          objMedidasMercancia.peso += objMercancia.dPeso;
          //si las mercancías estan una después de la otra, entonces el largo total es la suma de los largos de las mercancías.
          if (distribucionMerc === this.MERCANCIA_CONTIGUA) {
            objMedidasMercancia.largo += objMercancia.dLargo;
          }
          //si las mercancías estan sobrepuestas, entonces el alto total es la suma de los altos de la mercancías.
          if (distribucionMerc === this.MERCANCIA_ENCIMADA) {
            objMedidasMercancia.alto += objMercancia.dAlto;
          }
        });

        //el ancho siempre va a ser el máximo, a menos que puedan estar contiguas horizontalmente
        objMedidasMercancia.ancho = Math.max.apply(
          Math,
          lstMercancia.map((objMercancia) => {
            return objMercancia.dAncho;
          })
        );

        //si las mercancías estan sobrepuestas, entonces el largo total, es el máximo largo.
        if (distribucionMerc === this.MERCANCIA_ENCIMADA) {
          objMedidasMercancia.largo = Math.max.apply(
            Math,
            lstMercancia.map((objMercancia) => {
              return objMercancia.dLargo;
            })
          );
        }

        //si las mercancías estan una después de la otra, entonces el alto total, es el máximo alto.
        if (distribucionMerc === this.MERCANCIA_CONTIGUA) {
          objMedidasMercancia.alto = Math.max.apply(
            Math,
            lstMercancia.map((objMercancia) => {
              return objMercancia.dAlto;
            })
          );
        }
      }
    }

    return objMedidasMercancia;
  };

  handleClose = () => {
    this.dialogRef.close();
  };
}
